import script from "./CustomRepeater.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomRepeater.vue?vue&type=script&setup=true&lang=js"

import "./CustomRepeater.vue?vue&type=style&index=0&id=ee71ce8e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee71ce8e"]])

export default __exports__